module.exports = __webpack_public_path__ + "img/Bild Oraniencenter Präsentation-2.1a2db543.jpg";